import z from 'zod'

export const CancelReasonContext = {
  Subscription: 'subscription',
  Treat: 'treat',
  Supplement: 'supplement',
} as const
export type CancelReasonContext = typeof CancelReasonContext[keyof typeof CancelReasonContext]

// Note: Zod 3 can't infer recursive schemas directly and will instead produce an `any` type.
// The workaround is to define the type explicitly.
export interface CancelReason {
  id: string
  description: string
  slug: string
  displayOrder: number | null
  contexts: CancelReasonContext[]
  childReasons?: CancelReason[]
  isActive?: boolean
  /**
   * Indicates that this cancellation reason should be hidden from end-users
   */
  isHidden?: boolean
}

export const CancelReasonSchema: z.ZodType<CancelReason> = z.lazy(() => z.object({
  id: z.string().uuid(),
  description: z.string().max(255),
  slug: z.string(),
  displayOrder: z.number().int().nullable(),
  contexts: z.nativeEnum(CancelReasonContext).array(),
  childReasons: z.array(CancelReasonSchema).optional(),
  // Making these optional to avoid breaking contract in clients
  isActive: z.boolean().optional(),
  /**
   * Indicates that this cancellation reason should be hidden from end-users
   */
  isHidden: z.boolean().optional(),
})) as z.ZodType<CancelReason>
